import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=40af1ad4&scoped=true&"
import script from "./Header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=40af1ad4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af1ad4",
  null
  
)

export default component.exports